import React, { useState } from 'react';
import { X, User, Envelope, Phone, MapPin } from 'phosphor-react';
import './GuestQuoteModal.css';

const GuestQuoteModal = ({ isOpen, onClose, onSubmit, isSubmitting }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validação básica
    if (!formData.name.trim() || !formData.email.trim()) {
      alert('Nome e email são obrigatórios');
      return;
    }

    // Validação de email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      alert('Por favor, insira um email válido');
      return;
    }

    onSubmit(formData);
  };

  const handleClose = () => {
    if (!isSubmitting) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="guest-quote-modal-overlay">
      <div className="guest-quote-modal">
        <div className="modal-header">
          <h2>Informações para Orçamento</h2>
          <button 
            className="close-btn" 
            onClick={handleClose}
            disabled={isSubmitting}
          >
            <X size={24} />
          </button>
        </div>

        <div className="modal-content">
          <p className="modal-description">
            Para enviar o orçamento, precisamos de algumas informações básicas:
          </p>

          <form onSubmit={handleSubmit} className="guest-form">
            <div className="form-group">
              <label htmlFor="name">
                <User size={20} />
                Nome Completo *
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Seu nome completo"
                required
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">
                <Envelope size={20} />
                Email *
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="seu@email.com"
                required
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">
                <Phone size={20} />
                Telefone
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="Seu número de telefone"
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group">
              <label htmlFor="address">
                <MapPin size={20} />
                Morada
              </label>
              <input
                type="text"
                id="address"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                placeholder="Sua morada"
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">
                Observações
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                placeholder="Alguma observação adicional sobre o projeto..."
                rows={3}
                disabled={isSubmitting}
              />
            </div>

            <div className="form-actions">
              <button 
                type="button" 
                className="btn-cancel"
                onClick={handleClose}
                disabled={isSubmitting}
              >
                Cancelar
              </button>
              <button 
                type="submit" 
                className="btn-submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Enviando...' : 'Enviar Orçamento'}
              </button>
            </div>
          </form>

          <div className="modal-footer">
            <p className="privacy-note">
              🔒 Suas informações serão utilizadas apenas para envio do orçamento e não serão compartilhadas.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuestQuoteModal;
